import { ReactElement } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { Modal } from '@sc/shared-ui';
import { useLocation, useNavigate, useSearch } from '@tanstack/react-router';
import { BillingSubscriptionCreditsTab } from './BillingSubscriptionCreditsTab';
import { BillingPaymentMethodsTab } from './BillingPaymentMethodsTab';
import { BillingInvoicesTab } from './BillingInvoicesTab';

const tabClassName =
  'pt-3 px-3 pb-2.5 font-semibold data-selected:text-primary-400 hover:bg-grey-t-800 data-selected:border-primary-400 border-transparent border-b-2 outline-none';

export const Billing = (): ReactElement => {

  const { stripeState, invoice } = useSearch({
    from: '/_authenticated/billing',
  });

  const { hash } = useLocation();
  const navigate = useNavigate();

  const handleUpgrade = () => void navigate({ to: '/upgrade' });

  const selectedIndex = hash ? parseInt(hash) : invoice ? 2 : 0;

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="p-5">
        <h1 className="text-h1-small font-semibold font-grotesque">Billing</h1>
      </div>
      <TabGroup
        selectedIndex={selectedIndex}
        onChange={(index) =>
          void navigate({
            to: '/billing',
            hash: String(index),
          })
        }
        className="flex flex-col grow overflow-hidden"
      >
        <TabList className="space-x-2 px-5 border-b border-grey-t-800">
          <Tab className={tabClassName}>Subscription & usage</Tab>
          <Tab className={tabClassName}>Payment methods</Tab>
          <Tab className={tabClassName}>Invoices</Tab>
        </TabList>
        <TabPanels className="grow overflow-y-auto flex flex-col">
          <TabPanel>
            <BillingSubscriptionCreditsTab
              onUpgrade={handleUpgrade}
            />
          </TabPanel>
          <TabPanel>
            <BillingPaymentMethodsTab />
          </TabPanel>
          <TabPanel>
            <BillingInvoicesTab />
          </TabPanel>
        </TabPanels>
      </TabGroup>
      <Modal
        icon="success-info"
        hideTopHr
        open={stripeState === 'success'}
        title="Upgrading"
        dialogPanelClassname="w-120"
        loading
      >
        <div className="p-5">
          <p>Please wait whilst we upgrade your account...</p>
        </div>
      </Modal>
    </div>
  );
};
